import React from "react";
import { useState } from "react";
import { useSelector } from "react-redux";
import { ClassificationEnum } from "../../../../../models/ClassificationContentBankEnum";
import { ContentTypeEnum } from "../../../../../models/ContentTypeEnum";
import { onKeyDown } from "../../../../../service";
import AuthorIcon from '../../.././../../assests/MaterialLibrary/Author.png';
import classes from './UploadAuxiliary.module.css';

const UploadStep2 = ({ auxiliary, setStep, setAddItem }) => {
    const user = useSelector(state => state.auth.user);
    const texts = useSelector(state => state.translate.texts);

    const [lang, setLang] = useState()
    const handleAddToAuxiallary = () => {
        let data = {
            name: auxiliary.name,
            description: auxiliary.desc,
            // keywords: tags,
            // contentType: ContentTypeEnum.PDF,
            // externalId: selectedProject.id,
            file: auxiliary.file,
            lang: lang === "without" ? null : lang,
            classification: ClassificationEnum.auxiliary,
            thumbnail: auxiliary.thumbnail
        }
        setStep(3)
        setAddItem(data)
    }
    return (
        <>
            <div className={classes.Details}>
                <div className={classes.AuthorContainer}>
                    <img src={AuthorIcon} alt='AuthorIcon' />
                    <div className={classes.Author}>{texts.author} {user.firstName + " " + user.lastName}</div>
                </div>
                <div className={classes.OpeningImageContainer}>
                    {auxiliary?.thumbnail ? <img className={classes.OpeningImage} src={URL.createObjectURL(auxiliary.thumbnail)} alt="thumbnail" /> : ''}
                </div>
                <div className={classes.newAuxiliaryName}>{auxiliary?.name}</div>
            </div>
            <div className={classes.Title}>{texts.catalog}</div>
            <div className={classes.FilterAPIContainer}>
            </div>
            {/* <div className={classes.Catalog}>
                <div>
                    <div>{texts.curriculumFilter}</div>
                    <div className={classes.WrapInput}>
                        <select className={classes.Select}>
                            <option value={""}>{texts.all}</option>
                            {[1, 2, 3].map(item => <option key={item}>{item}</option>)}
                        </select>
                    </div>
                </div>
                <div>
                    <div>{texts.interestAreasFilter}</div>
                    <div className={classes.WrapInput}>
                        <select className={classes.Select} >
                            <option value={""}>{texts.all}</option>
                            {[1, 2, 3].map(item => <option key={item}>{item}</option>)}
                        </select>
                    </div>
                </div>
            </div> */}
            <div className={classes.More}>
                <div>{texts.filterByLanguage}</div>
                <div className={classes.ButtonsWarrper}>
                    {/* //TODO shulamit  correct langs */}
                    {["he", "ar", "without"].map(item =>
                        <div className={`${classes.Button} ${lang === item && classes.SelectedButton}`} key={item} onClick={() => setLang(item)} tabIndex="0" role="button" onKeyDown={e => onKeyDown(e, () => setLang(item))}>{texts[item]}</div>
                    )}
                </div>
                {/* <div className={classes.Tags}>{texts.tags}</div>
                <input type='text' className={`${classes.Input} ${classes.InputText}`} /> */}
            </div>
            <div className={`${classes.ImportBtn} ${classes.Btn}`} onClick={() => handleAddToAuxiallary()} tabIndex="0" role="button" onKeyDown={e => onKeyDown(e, () => handleAddToAuxiallary())}>{texts.end}</div>
        </>
    )
}

export default UploadStep2;